import { routes } from "configs";

export const EXCLUDED_ROUTES = [routes.streamingResources, routes.bitsbox];
export const EXCLUDED_ROUTES_FOR_TRANSLATE = [routes.bitsbox];

export const CHAM_TOKEN =
  "SGPRRK1wZofLL2xQRuzHYXPsxwsV4QER7IszrQTPnYJwYI-1P30gL-E4F628ltWCPuSy2R";
